export default "__VITE_ASSET__CPyTN3TW__"